<template>
  <div id="footballLeague_schedule" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>
    </div>
    <template v-if="themeItem && matchList && matchList.length > 0">
      <multipleChoiceShare_fixedBtn
        :model="multipleChoiceShareFixedBtn_model"
        :state="multipleChoiceShareFixedBtn_state"
        :modeType="multipleChoiceShareFixedBtn_modeType"
        :smallBtnArr="smallBtnArr"
        :fixedBtn_absTopArr="['18vw', '23.5vw']"
        @changeModelEvent="changeModelEventHandler"
        @clickSmallBtnEvent="clickSmallBtnEventHandler"
        @clickFixedBtnEvent="clickFixedBtnEventHandler"
        :isShow="!noData"
        :changeOptions="multipleChoiceShareFixedBtn_changeOptions"
        @changeTypeEvent="multipleChoiceShareFixedBtn_changeTypeEventHandler"
      ></multipleChoiceShare_fixedBtn>
    </template>
    <div class="selectTab_area" v-if="currStageMatchDate">
      <DateSelectTab
        :currThemeObj="currThemeObj"
        :tabArr="tabArr"
        :curDate="currStageMatchDate"
        :pageJumpParams="selectTab_pageJumpParams"
        :colorsArr="selectTab_colorsArr"
        :borderColor="true"
        @clickTabEvent="onChangeTab"
      ></DateSelectTab>
    </div>
    <div
      class="teamTable"
      :class="
        multipleChoiceShareFixedBtn_model === 'circular'
          ? 'multipleChoiceShare_fixedBtn_isCircular'
          : ''
      "
    >
      <div
        class="tableScrollArea"
        ref="tableParentDom"
        :class="
          tabArr && matchList && matchList.length === 0 ? 'showBorderTop' : ''
        "
      >
        <div :class="scrollDomClassName">
          <schedule_match_list
            v-if="matchList && matchList.length > 0"
            :currCid="currCid"
            :currSid="currSid"
            :currThemeObj="currThemeObj"
            :data="matchList"
            :detailPathName="`scheduleDetailIndex_${currThemeObj.moduleRouteNameEn}`"
            :chooseState="multipleChoiceShareFixedBtn_state"
            :localStorageName="
              multipleChoiceShareFixedBtn_modeType &&
              multipleChoiceShareFixedBtn_modeType.localStorageName
                ? multipleChoiceShareFixedBtn_modeType.localStorageName
                : ''
            "
            :localStorageSaveDate="currStageMatchDate"
            @changeChooseNumEvent="changeChooseNumEventHandler"
            :viewMode="currScheduleMatchList_viewMode"
            @clickMatchItemCheckboxItemEvent="
              clickMatchItemCheckboxItemEventHandler
            "
            :channelType="currScheduleMatchList_channelType"
            :matchModeObj="scheduleMatchList_matchMode"
          />
        </div>
        <cup_notData v-if="noData" className="relativePtb60"></cup_notData>
      </div>
    </div>
    <BackTop :showBackTop="showBackTop" :clickEvent="goBackTop"></BackTop>
    <complex_multipleChoiceShare_dialog
      v-if="dialogItem && dialogItem.isDialogFlag"
      :currThemeObj="currThemeObj"
      :axiosBaseUrl="axiosBaseUrl"
      :platfromMenu_currGroup="currGroup"
      :currCid="currCid"
      :currSid="currSid"
      :dialogItem="dialogItem"
      :themeItem="themeItem"
      :localStorageChooseList="localStorageChooseList"
      :multipleChoiceShareFixedBtn_modeType="
        multipleChoiceShareFixedBtn_modeType
      "
      :curTimeZoneItem="curTimeZoneItem"
      @dialogCancelEvent="dialogCancelEventHandler"
      @dialogOkEvent="dialogOkEventHandler"
      @shareDoneEvent="shareDoneEventHandler"
      :commitBeforeCheckoutCallback="
        multipleChoiceShare_commitBeforeCheckoutCallback
      "
    >
      <template v-slot:checkList>
        <schedule_match_list
          :currCid="currCid"
          :currSid="currSid"
          :currThemeObj="currThemeObj"
          :data="localStorageChooseList"
          :detailPathName="''"
          :chooseState="multipleChoiceShareFixedBtn_state"
          :localStorageName="
            multipleChoiceShareFixedBtn_modeType &&
            multipleChoiceShareFixedBtn_modeType.localStorageName
              ? multipleChoiceShareFixedBtn_modeType.localStorageName
              : ''
          "
          :localStorageSaveDate="currStageMatchDate"
          @changeChooseNumEvent="changeChooseNumEventHandler"
          :viewMode="currScheduleMatchList_viewMode"
          @clickMatchItemCheckboxItemEvent="
            clickMatchItemCheckboxItemEventHandler
          "
          :channelType="currScheduleMatchList_channelType"
          :matchModeObj="scheduleMatchList_matchMode"
        />
      </template>
    </complex_multipleChoiceShare_dialog>
  </div>
</template>

<script>
import {
  https_schedule_matchDateAndTeamList,
  https_schedule_weekList,
  https_schedule_matchList,
} from '@api/platfrom_basketball_api'
import BackTop from '@components/base/backTop.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import schedule_match_list from '@components/platfromBase/generalComponents/scheduleMatchList_compex/index.vue'
import multipleChoiceShare_fixedBtn from '@components/platfromBase/compreSportsMeet/multipleChoiceShare_fixedBtn.vue'
import complex_multipleChoiceShare_dialog from '@components/platfromBase/compreSportsMeet/complex_multipleChoiceShare_dialog.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import multipleChoiceShare_data_mixin from '@mixins/multipleChoiceShare_data'
import DateSelectTab from '@components/platfromBase/basketball/dateSelectTab.vue'
import cup_notData from '@components/base/NO_DATA.vue'

export default {
  name: 'footballLeague_schedule',
  components: {
    marathon_select_opt,
    BackTop,
    multipleChoiceShare_fixedBtn,
    complex_multipleChoiceShare_dialog,
    schedule_match_list,
    DateSelectTab,
    cup_notData,
  },
  mixins: [cup_base_data_mixin, multipleChoiceShare_data_mixin],
  props: {
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      select_opt_datePickerObject: {},
      // select_opt_inputObject: {
      //   inputTitle: '快速查询',
      //   placeholder: '请输入比赛名称',
      //   iconType: 'search',
      // }, //控制marathon_select_opt中的输入框是否显示
      isScrollBottom: false,
      firstPageIsScrollBottom: false,
      scrollDomClassName: 'scrollDomContain',
      scrollDomById: 'containerFull_body',
      loading: false,
      curMatchLabelFixedIcon: null,
      matchItemPbpx: 0,
      matchLabelArr: [],
      matchList: null,
      scheduleMatchList_matchMode: {
        mode: 'FootballLeague',
        type: '',
        filterCondition: '',
      },
      currStageMatchDate: '',
      currStageTeam: '',
      curInputVal: '',
      selectAllObj: {
        value: 'all',
        name: '全部',
      },
      teamArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'matchDate',
            title: '日期',
            origin_keyVal: ['value', 'name'],
            selectIndex: 0,
            isDatePicker: true,
          },
          {
            type: 'team',
            title: '球队',
            origin_keyVal: ['value', 'name'],
            dataName: 'teamArr',
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      showBackTop: false,
      themeTemplateType: 9,
      crossSeason: true, //cba 是跨赛季的, 在mixins中使用
      currScheduleMatchList_viewMode: '',
      currScheduleMatchList_channelType: 'radio',
      channelTv_changeOptions_index: -1,
      matchListViewMode: ['scheduleNoticeFBLCSL', 'scheduleListFBLCSL'], //这里的字符串相等于唯一id，不能一样
      multipleChoiceShareFixedBtn_modeType: null,
      multipleChoiceShareFixedBtn_changeOptions: [], // 分享赛程多个模式时的配置项
      // multipleChoiceShareFixedBtn_modeType: {
      //   index: 0,
      //   btnName: '创建赛程',
      //   type: 'scheduleListFBLCSL',
      //   localStorageName: 'mixtmt_choose_scheduleListFBLCSL',
      //   unit: '场',
      // },
      // multipleChoiceShareFixedBtn_changeOptions: [
      //   // 分享赛程多个模式时的配置项
      //   {
      //     btnName: 'L屏赛程预告',
      //     shortName: '预告',
      //     type: 'scheduleNoticeFBLCSL',
      //     unit: '场',
      //   },
      //   {
      //     btnName: '创建赛程',
      //     shortName: '赛程',
      //     type: 'scheduleListFBLCSL',
      //     unit: '场',
      //   },
      // ],
      tabArr: null,
      selectTab_pageJumpParams: [],
      selectTab_colorsArr: null,
      selectTab_colorsKey: [
        'greyColor7',
        'whiteColor',
        'greyColor2',
        'subColor1_1',
      ],
    }
  },
  created() {
    if (this.currGroup) {
      console.debug('init ')
      this.init()
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', () => {
      this.scrollListenerEvent()
    })
  },
  computed: {
    noData() {
      return this.matchList && this.matchList.length === 0
    },
  },
  methods: {
    async init() {
      if (this.currThemeObj) {
        this.selectTab_colorsArr = this.selectTab_colorsKey.map((key) => {
          return this.currThemeObj.cssStyle[key]
        })
      }
      console.debug('this.currGroup league_schedule:', this.currGroup)
      const query = this.$route.query
      const params = this.$route.params
      this.selectTab_pageJumpParams = [query, params]
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      console.debug(this.currCid, this.currSid)
      if (this.initFindanalysisItem && (!this.themeItem || !this.crossSeason)) {
        await this.initFindanalysisItem()
      }
      await this.getStageDateAndTeamList()
      await this.getWeekList()
      this.computedSelectOpt(this.selectOptData.configArr)

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    onChangeTab(item) {
      console.debug(item)
      this.tabArr.forEach((tabItem) => {
        if (item.id == tabItem.id) {
          tabItem.act = true
        } else {
          tabItem.act = false
        }
      })
      this.currDateSelectTabItem = {
        name: item.name,
        id: item.id,
      }
      this.getScheduleMatchList(item.id)
    },
    // inputValHandler(inputVal) {
    //   // 获取inputVal值
    //   console.debug('inputVal:', inputVal)
    //   this.curInputVal = inputVal
    //   this.getScheduleMatchList(this.currStageMatchDate)
    // },
    markChanleTv2MatchItem(channelTv_changeOptions_index) {
      // 初始化 matchList 数据，将主题中的频道下拉框数据赋值比赛中
      if (channelTv_changeOptions_index === -1 || !this.inFilter_channelTvObj)
        return
      const channelTv_localStorageName = `mixtmt_choose_${this.matchListViewMode[channelTv_changeOptions_index]}` // 频道主题缓存中的名字
      const chooseObj = this.getLocalStorageChooseObj(
        channelTv_localStorageName
      )
      console.debug('chooseObj:', chooseObj, channelTv_localStorageName)
      if (
        chooseObj &&
        chooseObj.chooseItemArr &&
        chooseObj.chooseItemArr.length > 0
      ) {
        // 判断缓存中的 channelTvList 是否与当前的 channelTvList 一致，如果不一致取新的，如果一致则取缓存
        let isDiffDataFlag = true //缓存中的数据是否与新的数据一致
        let localStorage_channelTvList = chooseObj.chooseItemArr[0]
          .channelTvList
          ? chooseObj.chooseItemArr[0].channelTvList
          : []
        const new_channelTvList = this.inFilter_channelTvObj.values
        if (localStorage_channelTvList.length !== new_channelTvList.length) {
          // 个数比较
          isDiffDataFlag = false
        }
        if (isDiffDataFlag) {
          let diffIdNum = 0 // 相同value的个数
          localStorage_channelTvList.forEach((localChannelItem) => {
            new_channelTvList.forEach((newChannelItem) => {
              if (newChannelItem.value === localChannelItem.value) {
                diffIdNum++
                if (newChannelItem.name !== localChannelItem.name) {
                  isDiffDataFlag = false
                }
              }
            })
          })
          if (isDiffDataFlag) {
            // 个数虽然相同，然后对比2个数组中它们的value是的都一致
            if (diffIdNum !== localStorage_channelTvList.length) {
              isDiffDataFlag = false
            }
          }
        }
        this.isDiffDataFlag = isDiffDataFlag
      }
      this.matchList = this.matchList.map((item) => {
        item.channelTvList = JSON.parse(
          JSON.stringify(
            this.inFilter_channelTvObj.values.map((valObj, valIndex) => {
              if (valIndex === 0) {
                valObj.act = true
              } else {
                valObj.act = false
              }
              return valObj
            })
          )
        )
        return item
      })
      console.debug('markChanleTv2MatchItem:', this.matchList)
    },
    multipleChoiceShare_initThemeListCallback(themeList) {
      console.debug('multipleChoiceShare_initThemeListCallback:', themeList)
      // 当获取到主题list数据后，将主题中的数据赋值到其他地方
      if (!themeList || themeList.length === 0) return
      let changeOptions = []
      this.channelTv_changeOptions_index = -1 //存储频道主题在multipleChoiceShareFixedBtn_changeOptions中的索引
      this.inFilter_channelTvObj = null //切换赛季时需要重新获取主题列表，判断是否有频道
      themeList.forEach((themeItem, themeIndex) => {
        if (themeItem.graphicsId === 39) {
          // 赛程预告
          let type = this.matchListViewMode[0]
          changeOptions[themeIndex] = {
            index: themeIndex,
            btnName: themeItem.analysisItemName,
            shortName: '预告',
            type,
            localStorageName: `mixtmt_choose_${type}`,
            unit: '场',
            customkeyArrActJson: {},
          }
          this.channelTv_changeOptions_index = themeIndex
          this.inFilter_channelTvObj = themeItem.inFilter
            ? themeItem.inFilter.filterTypes[0]
            : null
          if (this.inFilter_channelTvObj && this.inFilter_channelTvObj.values) {
            this.inFilter_channelTvObj.values.forEach((channelItem) => {
              channelItem.value = channelItem.value + ''
            })
            // this.inFilter_channelTvObj.name => 'channel'
            changeOptions[themeIndex].customkeyArrActJson['actChannelArr'] = {
              // 频道选择，二维数组，最后从缓存数据中组装数据，放到json中的数据，提交创建主题，this.matchList中的单场比赛不需要这个字段
              type: 'Array', //放到json里面字段值类型是数组
              isOnly: false, //是否去重
              keyArr: [this.inFilter_channelTvObj.name, 'actChannelArr'], //[上传数据json对象里面的字段值，第一个元素里面存储的val值（从chooseItemArr里面取的字段名）]
            }
          }
        } else if (themeItem.graphicsId === 38) {
          // 比赛列表
          let type = this.matchListViewMode[1]
          changeOptions[themeIndex] = {
            index: themeIndex,
            btnName: themeItem.analysisItemName,
            shortName: '比赛',
            type,
            localStorageName: `mixtmt_choose_${type}`,
            unit: '场',
          }
        }
      })
      this.multipleChoiceShareFixedBtn_changeOptions = changeOptions
      this.multipleChoiceShareFixedBtn_changeScheduleMatchListView(0)
    },
    multipleChoiceShareFixedBtn_changeScheduleMatchListView(actIndex) {
      this.multipleChoiceShareFixedBtn_modeType =
        this.multipleChoiceShareFixedBtn_changeOptions[actIndex]
      this.currScheduleMatchList_viewMode = this.matchListViewMode[actIndex]
    },
    multipleChoiceShareFixedBtn_closeDialogResetData() {
      if (
        this.multipleChoiceShareFixedBtn_modeType.type ===
        this.matchListViewMode[0]
      ) {
        // 频道预告
      }
    },
    // multipleChoiceShareFixedBtn_clickFixedBtnBeforeHandler() {
    //   // 再点击按钮前【触发多选操作时】，对当前页面数据进行处理
    // },
    multipleChoiceShareFixedBtn_changeTypeEventHandler(data) {
      // 分享赛程切换模式时执行的函数，支持2或大于2个以上的选项切换
      // let multipleChoiceShareFixedBtn_modeType = null
      // let actIndex =
      //   data.index + 1 >= this.multipleChoiceShareFixedBtn_changeOptions.length
      //     ? 0
      //     : data.index + 1
      // this.multipleChoiceShareFixedBtn_changeOptions.forEach(
      //   (opts, optIndex) => {
      //     if (opts.type !== data.type && actIndex === optIndex) {
      //       this.multipleChoiceShareFixedBtn_changeScheduleMatchListView(
      //         optIndex
      //       )
      //       this.themeItem = this.formatThemeListArr[optIndex]
      //       console.debug('this.themeItem:', this.themeItem, data)
      //     }
      //   }
      // )
      // this.isClearlearLocalStorageChoose()
      if (data) {
        let multipleChoiceShareFixedBtn_modeType = null
        if (data.type === 'rect') {
          // 分享赛程切换模式时执行的函数，支持2或大于2个以上的选项切换
          let actIndex =
            data.modeType.index + 1 >=
            this.multipleChoiceShareFixedBtn_changeOptions.length
              ? 0
              : data.modeType.index + 1
          this.multipleChoiceShareFixedBtn_changeOptions.forEach(
            (opts, optIndex) => {
              if (opts.type !== data.modeType.type && actIndex === optIndex) {
                this.multipleChoiceShareFixedBtn_changeScheduleMatchListView(
                  optIndex
                )
                this.themeItem = this.formatThemeListArr[optIndex]
              }
            }
          )
        } else if (data.type === 'circular') {
          // 圆型时传来的就是选中的主题
          let actIndex = data.modeType.index
          this.multipleChoiceShareFixedBtn_changeOptions.forEach(
            (opts, optIndex) => {
              if (opts.type === data.modeType.type && actIndex === optIndex) {
                this.multipleChoiceShareFixedBtn_changeScheduleMatchListView(
                  optIndex
                )
                this.themeItem = this.formatThemeListArr[optIndex]
              }
            }
          )
        }
        this.isClearlearLocalStorageChoose()
      }
    },
    goBackTop() {
      if (this.scrollAreaDom) {
        this.scrollAreaDom.scrollTo(0, 0)
      }
    },
    initScroll() {
      if (this.scrollAreaDom) {
        return
      }

      console.debug('this.scrollAreaDom:', this.scrollAreaDom)
      this.beforeScrollTop = 0
      // this.threshold = 5
      // this.DIRECTION_ENUM = {
      //   DOWN: 'down',
      //   UP: 'up',
      // }

      this.scrollAreaDom = document.getElementById(`${this.scrollDomById}`)

      console.debug('this.scrollAreaDom:', this.scrollAreaDom)
      this.scrollAreaDom.addEventListener('scroll', () => {
        this.scrollListenerEvent()
      })
    },
    scrollListenerEvent() {
      console.debug('scrollListenerEvent')
      const scrollTop = this.scrollAreaDom.scrollTop

      if (scrollTop > 300) {
        this.showBackTop = true
      } else {
        this.showBackTop = false
      }

      // multipleChoiceShare_fixedBtn 需要
      this.scrollChangeHandler(scrollTop)

      this.beforeScrollTop = this.scrollAreaDom.scrollTop
    },
    changeChooseNumEventHandler(data) {
      // 这个是多选分享每个.vue文件根据数据结构，单独写的
      if (data.init) {
        // 清除缓存，重新开始
        this.$localStorage.removeItem(
          data.localStorageName //this.multipleChoiceShareFixedBtn_modeType.localStorageName
        )
        // multipleChoiceShare_fixedBtn 组件清除缓存数据时，源数据是否要重置
        this.matchList.forEach((match) => {
          match.isChooseFlag = false
          if (data.type === this.matchListViewMode[0]) {
            // 频道预告
            if (match.channelTvList) {
              const channelTvList = JSON.parse(
                JSON.stringify(match.channelTvList)
              )
              channelTvList.forEach((item, itemIndex) => {
                if (itemIndex === 0) {
                  item.act = true
                } else {
                  item.act = false
                }
              })
              match.channelTvList = channelTvList
            }
          }
        })
      } else {
        const chooseSchedule = JSON.parse(
          this.$localStorage.getItem(
            data.localStorageName //this.multipleChoiceShareFixedBtn_modeType.localStorageName
          )
        )
        console.debug('data.type:', data, chooseSchedule)
        let matchList = JSON.parse(JSON.stringify(this.matchList))
        matchList.forEach((item) => {
          if (chooseSchedule.chooseIdArr.includes(item.chooseId)) {
            item.isChooseFlag = true
            // 只有多选的才会 data.type
            if (data.type === this.matchListViewMode[0]) {
              // 赛程预告
              chooseSchedule.chooseItemArr.forEach((chooseItem) => {
                if (chooseItem.chooseId === item.chooseId) {
                  if (this.isDiffDataFlag) {
                    // 数据一致
                    item.channelTvList = chooseItem.channelTvList
                    console.debug('chooseItem:', chooseItem)
                  } else {
                    // 数据不一致，全部保持数据初始化状态
                  }
                }
              })
            }
          } else {
            item.isChooseFlag = false
          }
        })
        this.matchList = matchList
        this.$localStorage.setItem(
          data.localStorageName,
          JSON.stringify(chooseSchedule)
        )
        this.localStorageChooseList = chooseSchedule.chooseItemArr
      }
      this.smallBtnArr.forEach((item) => {
        if (item.type === 'check') {
          item.val = data.val
        }
      })
    },
    multipleChoiceShare_commitBeforeCheckoutCallback(
      multipleChoiceShareFixedBtn_modeType
    ) {
      console.debug(
        'multipleChoiceShareFixedBtn_modeType:',
        multipleChoiceShareFixedBtn_modeType
      )
      let isCheckoutFlag = true
      let errorTipText = ''
      if (
        multipleChoiceShareFixedBtn_modeType.type === this.matchListViewMode[0]
      ) {
        // 频道预告需要验证
        for (let i = 0; i < this.matchList.length; i++) {
          const matchItem = this.matchList[i]
          if (matchItem.isChooseFlag && matchItem.channelTvList) {
            // 比赛被选中且频道数组中没有元素时，不能创建，提示未选择频道
            let isActChooce = false
            matchItem.channelTvList.forEach((channelItem) => {
              if (channelItem.act) {
                isActChooce = true
              }
            })

            if (!isActChooce) {
              // 如果 isActChooce 没有为 true 则证明选中的比赛中有没有选中的频道，所以为 false；因此验证不通过，跳出循环
              isCheckoutFlag = false
              break
            }
          }
        }
        errorTipText = '分享的比赛中存在【未选择频道】的比赛'
      }
      console.debug('this.matchList:', this.matchList)
      if (isCheckoutFlag) {
        // 验证通过，直接组装缓存数据中的 actChannelArr 数据，创建的时候是从缓存中取数据的
        let chooseObj = this.getLocalStorageChooseObj(
          multipleChoiceShareFixedBtn_modeType.localStorageName
        )
        chooseObj.chooseIdArr.forEach((chooseId) => {
          let actChannelArr = []
          chooseObj.chooseItemArr.forEach((chooseItem) => {
            if (chooseItem.chooseId === chooseId && chooseItem.channelTvList) {
              chooseItem.channelTvList.forEach((channelItem) => {
                if (channelItem.act) {
                  actChannelArr.push(channelItem.value)
                }
              })
              chooseItem.actChannelArr = actChannelArr
            }
          })
        })
        this.$localStorage.setItem(
          multipleChoiceShareFixedBtn_modeType.localStorageName,
          JSON.stringify(chooseObj)
        )
      }
      return { isCheckoutFlag, errorTipText }
    },
    updateLocalStorageHandler(localStorageName, matchItem, actItem, type) {
      // 这个是 schedule_match_list 中选择频道功能与 multipleChoiceShare_fixedBtn 组件组合时单独自定义的函数；将每次被选中比赛中的频道修改及时同步到缓存中
      let chooseObj = this.$localStorage.getItem(localStorageName)
        ? JSON.parse(this.$localStorage.getItem(localStorageName))
        : {
            cid: this.currCid,
            // date: this.localStorageSaveDate,
            chooseItemArr: [],
            chooseIdArr: [],
          }
      if (chooseObj.cid === this.currCid) {
        if (chooseObj.chooseItemArr.length === 0) {
          // 因为只是点击频道选择，执行此函数证明，缓存中有数据，所以不会走到这里
          // this.matchList.forEach((matchItem) => {
          //   if (matchItem.isChooseFlag) {
          //     chooseObj.chooseItemArr.push(matchItem)
          //     chooseObj.chooseIdArr.push(matchItem.chooseId)
          //   }
          // })
        } else {
          // 这里是缓存中的数据，已经是被选中的比赛了，所以不用再判断是否被选中了
          if (type) {
            if (type === 'checkbox') {
              // 多选逻辑
              chooseObj.chooseItemArr.forEach((match) => {
                if (match.chooseId === matchItem.chooseId) {
                  match.channelTvList.forEach((channleItem) => {
                    if (channleItem.value === actItem.value) {
                      channleItem.act = !channleItem.act
                    }
                  })
                }
              })
            } else if (type === 'radio') {
              // 单选逻辑
              chooseObj.chooseItemArr.forEach((match) => {
                if (match.chooseId === matchItem.chooseId) {
                  match.channelTvList.forEach((channleItem) => {
                    if (channleItem.value === actItem.value) {
                      channleItem.act = true
                    } else {
                      channleItem.act = false
                    }
                  })
                }
              })
            }
          }
        }
        this.$localStorage.setItem(localStorageName, JSON.stringify(chooseObj))
        this.localStorageChooseList = chooseObj.chooseItemArr
        console.debug('chooseObj:', chooseObj)
      } else {
        console.error('错误：赛事不同')
      }
    },
    clickMatchItemCheckboxItemEventHandler(data) {
      // cba单选， 亚运会多选
      // 这个是 schedule_match_list 中选择频道功能与 multipleChoiceShare_fixedBtn 组件组合时单独自定义的函数；将每次被选中比赛中的频道修改及时同步到缓存中
      let isUpdateLocalStroge = false
      let { matchItem, actItem, type } = data
      console.debug('clickMatchItemCheckboxItemEventHandler:', type)
      let matchList = JSON.parse(JSON.stringify(this.matchList))
      if (type === 'checkbox') {
        // 多选逻辑
        matchList.forEach((match) => {
          if (match.chooseId === matchItem.chooseId) {
            match.channelTvList.forEach((channleItem) => {
              if (channleItem.value === actItem.value) {
                channleItem.act = !channleItem.act
              }
            })
            if (match.isChooseFlag) {
              isUpdateLocalStroge = true
            }
          }
        })
      } else if (type === 'radio') {
        // 单选逻辑
        matchList.forEach((match) => {
          if (match.chooseId === matchItem.chooseId) {
            match.channelTvList.forEach((channleItem) => {
              if (channleItem.value === actItem.value) {
                channleItem.act = true
              } else {
                channleItem.act = false
              }
            })
            if (match.isChooseFlag) {
              isUpdateLocalStroge = true
            }
          }
        })
      }
      this.matchList = matchList
      if (isUpdateLocalStroge) {
        // 如果该比赛被选中，则需要将频道数据同步到缓存中，否则不需要同步缓存数据;
        // 由于缓存中可能会存储多天的比赛数据，所以不能再matchList中将被选中的数据替换到缓存中
        this.updateLocalStorageHandler(
          this.multipleChoiceShareFixedBtn_modeType.localStorageName,
          matchItem,
          actItem,
          this.currScheduleMatchList_channelType
        )
      }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = []
        if (config.isDatePicker) {
          // 日期选择框没有 dataName 属性
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: mix_id, //list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: this.currStageMatchDate ? this.currStageMatchDate : '', // 这个值是源数据需要展示的值，没有做过修改
            disabledArr,
            list,
            isDatePicker: config.isDatePicker,
          })
        } else {
          list = this[config.dataName].map((item) => {
            item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
            return item
          })
          console.debug(
            'computedSelectOpt:',
            config.dataName,
            this[config.dataName],
            list,
            mix_id
          )
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            isFilterable: config.isFilterable ? config.isFilterable : false,
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'team') {
            this.currStageTeam = valPathArr[1]
            console.debug('currStageMatchDate:', this.currStageMatchDate)
            // this.computedSelectOpt(this.selectOptData.configArr)
          } else {
          }
          // 筛选表格逻辑
          this.getScheduleMatchList(this.currStageMatchDate)
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else if (data.type === 'datePicker') {
        this.currStageMatchDate = val
        this.getWeekList()
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    async getStageDateAndTeamList() {
      await https_schedule_matchDateAndTeamList(
        this.axiosBaseUrl,
        this.$axios,
        {
          cid: this.currCid,
        }
      )
        .then((response) => {
          const res = response.data

          if (res.status === 0) {
            this.currStageMatchDate = res.data.scheduleDate
            const teamArr = res.data.teams
              ? res.data.teams.map((item) => {
                  return {
                    value: item.teamId,
                    name: item.teamName,
                  }
                })
              : []

            this.teamArr = [].concat(
              JSON.parse(JSON.stringify(this.selectAllObj)),
              teamArr
            )
            if (this.teamArr.length > 0) {
              this.currStageTeam = this.teamArr[0].value
            }
            console.debug('getStageDateAndTeamList:', this.teamArr)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    initGetMatchList(secNum) {
      setTimeout(() => {
        if (this.themeItem) {
          this.markChanleTv2MatchItem(this.channelTv_changeOptions_index)
          // this.getScheduleMatchList(this.currStageMatchDate)
        } else {
          this.initGetMatchList()
        }
      }, secNum)
    },
    async getWeekList() {
      let params = {
        date: this.currStageMatchDate,
      }
      await https_schedule_weekList(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            let initDateFlag = false
            let tabArr = res.data.map((dateItem) => {
              let name = '',
                act = false,
                dateCN = ''
              dateCN = dateItem.chineseDay
              if (dateItem.dayNum) {
                let nameArrs = dateItem.dayNum.split('-')
                name = `${dateCN} ${nameArrs[1] ? nameArrs[1] : ''}月${
                  nameArrs[2] ? nameArrs[2] : ''
                }日`
                if (this.currStageMatchDate === dateItem.dayNum) {
                  act = true
                  initDateFlag = true
                  this.currDateSelectTabItem = {
                    name,
                    id: dateItem.dayNum,
                  }
                }
              } else {
                name = `${dateCN} -月-日`
                this.currDateSelectTabItem = {
                  name: '未定义',
                  id: '-1',
                }
              }
              return {
                name,
                id: dateItem.dayNum,
                act,
              }
            })
            if (!initDateFlag) {
              // 异常处理，如果没有找到日期，则默认第一个日子
              tabArr[0].act = true
              this.currDateSelectTabItem = {
                name: tabArr[0].name,
                id: tabArr[0].id,
              }
            }
            this.tabArr = tabArr
            this.getScheduleMatchList(this.currStageMatchDate)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    computedMatchList(list) {
      console.debug('computedMatchList:', list, this.currDateSelectTabItem)
      if (list && list.length > 0) {
        this.matchList = list.map((item) => {
          let newItem = item
          newItem.gameDate = newItem.matchDate
          newItem.gameTime = newItem.matchTime
          newItem.chooseId = item.matchId
          newItem.isChooseFlag = false
          newItem.weekCN =
            this.currDateSelectTabItem && this.currDateSelectTabItem.name
              ? this.currDateSelectTabItem.name.split(' ')[0]
              : ''
          return newItem
        })
      } else {
        this.matchList = []
      }
    },
    async getScheduleMatchList(currTabDate) {
      let params = {
        cid: this.currCid,
        date: currTabDate ? currTabDate : '',
        tid: this.currStageTeam
          ? this.currStageTeam == 'all'
            ? ''
            : this.currStageTeam
          : '',
      }
      console.debug(params)
      await https_schedule_matchList(this.axiosBaseUrl, this.$axios, params)
        .then((response) => {
          const res = response.data
          console.debug('response:', res)
          if (res.status === 0) {
            if (res.data) {
              this.matchList = []
              this.matchLabelArr = []
              this.curMatchLabelFixedIcon = null
              this.initScroll()
              this.computedMatchList(res.data)
            } else {
              console.debug('暂无数据')
            }
            // console.debug('暂无数据:', this.matchList, this.matchList.length)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      // 主题初始化后，确定当前某个主题后，查询是否有缓存数据
      // this.isClearlearLocalStorageChoose()
      // this.markChanleTv2MatchItem(this.channelTv_changeOptions_index)
      this.initGetMatchList(100)
    },
  },
}
</script>

<style lang="scss" scoped>
#footballLeague_schedule {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }
  .selectTab_area {
    margin-top: 2.778vw;
    width: 100%;
    height: 2.778vw;
  }
  .teamTable {
    padding-bottom: 2.778vw;

    .tableScrollArea {
      &.showBorderTop {
        border-top: 1px solid var(--mixtmt_greyColor5);
      }
    }
    /* &.multipleChoiceShare_fixedBtn_isCircular {
        } */
  }
}
</style>
